module.exports = __webpack_public_path__ + "static/media/edyoda_logo.7b02514b.PNG";